/**
 * @file 保存图片
 * @author liudy
 */
import Api from '../../../path';
import { fetchData } from '@umu/umu-fetch';

export interface IInputItem {
    media_id: string;
    title?: string;
    rotate?: number;
    width?: number;
    height?: number;
    id?: string;
}

export interface IInput {
    element_id: number;
    from: string;
    photo_list: string; //  IInputItem[];
}

export interface IOutputItem {
    id: string;
    media_id: string;
    rotate: number;
    title: string;
    width: string;
    height: number;
    photo_url: {
        100: string;
        500: string;
        source: string;
    };
}

export interface IOutput {
    fail_list: boolean;
    photo_data: IOutputItem[];
}

export const savePhoto = (data: IInput): Promise<IOutput> => {
    return fetchData(Api.PHOTO_UPLOAD_PHOTO, data).then((res: IResponse<IOutput>) => {
        return res.data as IOutput;
    });
};
